/*=========================================================================================
  File Name: moduleBrandMutations.js
  Description: Brand Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  
};
